import { Injectable } from '@angular/core';

@Injectable()
export class BackofficeSortService {

  constructor() { }

  public sortNumeric(a: number, b: number, isAsc: boolean): number {
    return isAsc ? a.toString()?.localeCompare(b.toString(), 'en', { numeric: true }) : b.toString()?.localeCompare(a.toString(), 'en', { numeric: true });
  }

  public sortAlphanumeric(a: string, b: string, isAsc: boolean): number {
    return isAsc ? a?.localeCompare(b, 'en', { numeric: true }) : b?.localeCompare(a, 'en', { numeric: true });
  }

  public sortDate(dateA: Date, dateB: Date, isAsc : boolean) : number{
    return isAsc ? dateA?.getTime().toString()?.localeCompare(dateB?.getTime().toString()) : dateB?.getTime().toString().localeCompare(dateA?.getTime().toString());
  }
}
